import {getQuery} from "../../common/utils";

const getSmsBalance = async (businessUid) => {
  try {
    let result;
    result = await getQuery(`platform/v1/businesses/${businessUid}/sms_balance`)
    result = result.data;
    if (result !== null && typeof result === 'object') {
      result = result.data
    }

    return result;
  }
  catch (error) {
    console.error(error)
    return null;
  }
}

export const smsService = {
  getSmsBalance
}
